import React from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function AiConsentModal({ user, profile, onClose }) {
  // Hooks FIRST, unconditionally
  const [aiConsent, setAiConsent] = React.useState(
    profile?.aiPersonalizationConsent === true
  );
  const [voiceConsent, setVoiceConsent] = React.useState(
    profile?.voiceEmotionConsent === true
  );

  if (!user) return null;

  const aiSet = typeof profile?.aiPersonalizationConsent === "boolean";
  const voiceSet = typeof profile?.voiceEmotionConsent === "boolean";
  const shouldShow = !aiSet || !voiceSet;

  if (!shouldShow) return null;

  const handleSave = async () => {
    await updateDoc(doc(db, "userProblems", user.uid), {
      aiPersonalizationConsent: aiConsent,
      voiceEmotionConsent: voiceConsent,
    });
    onClose && onClose();
  };

  const handleSkip = async () => {
    await updateDoc(doc(db, "userProblems", user.uid), {
      aiPersonalizationConsent: false,
      voiceEmotionConsent: false,
    });
    onClose && onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20000,
      }}
      aria-modal="true"
      role="dialog"
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 12,
          maxWidth: 480,
          width: "90%",
          padding: 24,
          boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
          fontFamily: "'Segoe UI', sans-serif",
        }}
      >
        <h2 style={{ marginTop: 0 }}>AI features & your data</h2>
        <p style={{ fontSize: 14 }}>
          Bolo can analyze your logs and optional voice clips to show weekly
          reflections and small, non-medical suggestions. This is optional and you
          can change it anytime in settings.
        </p>

        <label style={{ display: "block", marginTop: 16, fontSize: 14 }}>
          <input
            type="checkbox"
            checked={aiConsent}
            onChange={(e) => setAiConsent(e.target.checked)}
          />{" "}
          Allow Bolo to analyze my logs for weekly reflections and suggestions.
        </label>
        <small style={{ fontSize: 12, color: "#555" }}>
          Used only inside Bolo to summarize your week and help you plan small steps.
        </small>

        <label style={{ display: "block", marginTop: 16, fontSize: 14 }}>
          <input
            type="checkbox"
            checked={voiceConsent}
            onChange={(e) => setVoiceConsent(e.target.checked)}
          />{" "}
          Allow Bolo to analyze my voice clips for emotion to personalize reflections.
        </label>
        <small style={{ fontSize: 12, color: "#555" }}>
          Voice is processed in the EU and only derived emotion scores are stored.
        </small>

        <div style={{ marginTop: 24, display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button
            onClick={handleSkip}
            style={{
              padding: "8px 14px",
              borderRadius: 6,
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              cursor: "pointer",
            }}
          >
            Skip for now
          </button>
          <button
            onClick={handleSave}
            style={{
              padding: "8px 16px",
              borderRadius: 6,
              border: "none",
              backgroundColor: "#0077cc",
              color: "white",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Save choices
          </button>
        </div>
      </div>
    </div>
  );
}
